import React, { useState, useEffect } from 'react';
import { FaMoneyBillAlt, FaFileAlt } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";
import { RiDeleteBin5Line } from "react-icons/ri";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import './payroll.css'; // Import the CSS file
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';

export default function MyPayroll() {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  // Validate form inputs
  const validateForm = () => {
    const errors = {};
    if (!startDate) errors.startDate = 'Start Date is required';
    if (!endDate) errors.endDate = 'End Date is required';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Mock data for payroll
  const mockPayData = Array.from({ length: 30 }, (_, index) => ({
    id: index + 1,
    name: `Employee ${index + 1}`,
    month: 'September',
    monthhours: `200 ${index + 1}`,
    overtime: '0',
    netpay: `10000`,
  }));

  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const totalPages = Math.ceil(mockPayData.length / rowsPerPage);

  useEffect(() => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    setData(mockPayData.slice(startIndex, endIndex));
  }, [currentPage]);
  

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => {
    const pages = [];
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const handleGenerateReport = () => {
    if (validateForm()) {
      console.log('Generate Report button clicked');
      setShowTable(true);
    }
  };

  const exportToExcel = () => {
    const data = [
      ["Employee Name", "Month", "Month Hours", "Over Time Hours", "Net Pay", "Status"],
      ["John Doe", "August", "160", "10", "$2000", "Paid"],
    ];

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Payroll Report");
    XLSX.writeFile(wb, "Payroll_Report.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text("Payroll Report", 10, 10);
    doc.text("Employee Name: John Doe", 10, 20);
    doc.text("Month: August", 10, 30);
    doc.text("Month Hours: 160", 10, 40);
    doc.text("Over Time Hours: 10", 10, 50);
    doc.text("Net Pay: $2000", 10, 60);
    doc.text("Status: Paid", 10, 70);
    doc.save("Payroll_Report.pdf");
  };

  const handlePayinClick = () => {
    navigate('/pay-invoice');
  };

  const showingEntriesInfo = () => {
    const startIndex = (currentPage - 1) * rowsPerPage + 1;
    const endIndex = Math.min(currentPage * rowsPerPage, mockPayData.length);
    return `Showing ${startIndex} to ${endIndex} of ${mockPayData.length} entries`;
  };
  return (
    <div className='container-fluid'>
      <h1 className='payroll-title'>
        <FaMoneyBillAlt className='payroll-icon' /> Payroll Reports
      </h1>
      <hr />
      <h1 className='payroll-subtitle'>
        <CgProfile className='payroll-icon' /> Your Name:
      </h1>
      <hr />

      <Form className='payroll-form'>
        <Row>
          <Col md={6} xs={12}>
            <Form.Group>
              <Form.Label>Start date <span className='required'>*</span> :</Form.Label>
              <Form.Control
                type="date"
                required
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                isInvalid={!!formErrors.startDate}
              />
              <Form.Control.Feedback type="invalid">{formErrors.startDate}</Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6} xs={12}>
            <Form.Group>
              <Form.Label>End date <span className='required'>*</span> :</Form.Label>
              <Form.Control
                type="date"
                required
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                isInvalid={!!formErrors.endDate}
              />
              <Form.Control.Feedback type="invalid">{formErrors.endDate}</Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
        <Button
          className='generate-report-button'
          variant='primary'
          type='button'
          onClick={handleGenerateReport}
        >
          Generate Report
        </Button>
      </Form>

      {showTable && (
        <div className='payroll-table-container'>
          <div className='table-actions'>
            <Row className='w-100'>
              <Col xs={12} md={6} className='d-flex align-items-center justify-content-start'>
                <Button variant="secondary" className='export-button' onClick={exportToExcel}>Excel</Button>
                <Button variant="secondary" className='export-button' onClick={exportToPDF}>PDF</Button>
              </Col>
              <Col xs={12} md={6} className='d-flex align-items-center justify-content-end'>
                <Form className="d-flex justify-content-end">
                  <Form.Control
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                    className="search-bar"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </Form>
              </Col>
            </Row>
          </div>
          <div className="table-responsive">
            <table className='table table-striped payroll-table'>
              <thead className='payroll-table-header-footer'>
                <tr>
                  <th>Employee Name</th>
                  <th>Month</th>
                  <th>Month Hours</th>
                  <th>Over Time Hours</th>
                  <th>Net Pay</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data.map(item => (
                  <tr key={item.id}>
                    <td>{item.name}</td>
                    <td>{item.month}</td>
                    <td>{item.monthhours}</td>
                    <td>{item.overtime}</td>
                    <td>{item.netpay}</td>
                    <td>
                      <Button variant='warning' size='sm' onClick={handlePayinClick}>
                        <FaFileAlt />
                      </Button>
                    </td>
                    <td>
                      <Button variant='danger' size='sm'>
                        <RiDeleteBin5Line />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className='payroll-table-header-footer'>
                <tr className='table-footer'>
                  <td>Total</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>

            <div className="d-flex justify-content-between align-items-center">
              <div className="entries-info">
                {showingEntriesInfo()}
              </div>
              <nav>
                <ul className="pagination justify-content-center">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <Button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </Button>
                  </li>

                  {pageRange().map(page => (
                    <li
                      key={page}
                      className={`page-item ${currentPage === page ? 'active' : ''}`}
                    >
                      <Button
                        className="page-link"
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </Button>
                    </li>
                  ))}

                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <Button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </Button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
